module.exports = "images/line.gif";